// extracted by mini-css-extract-plugin
export default {"content-window":"ContentWindow_content-window__Pegex"};